'use client';
import { useNewThreadNavigation } from '#pplx/frontend/apps/ask/keyboard-shortcuts-builtins/useNewThreadNavigation.js';
import { useRegisterShortcut, useShortcutRegistry, } from '#pplx/frontend/apps/ask/keyboard-shortcuts-provider/registry.js';
import { ModalOrigin } from '#pplx/frontend/components/types/types.js';
import { useCallback } from 'react';
/**
 * Registers the **base** New Thread global shortcut:
 *   - macOS: Cmd+K
 *   - Windows/Linux: Ctrl+I
 *
 * Keybinding, label, and group are resolved from the shortcut manifest.
 *
 * Handles standard search navigation + loss aversion.
 */
export function useNewThreadShortcut() {
    const newThread = useNewThreadNavigation(ModalOrigin.NEW_THREAD_SHORTCUT);
    const { isMacOS } = useShortcutRegistry();
    const handler = useCallback((e) => {
        // Prevent the browser's default action for the key combo (e.g. Cmd+K
        // opens the browser address bar on Chrome, Ctrl+I toggles italic in
        // contenteditable areas).
        e.preventDefault();
        newThread();
    }, [newThread]);
    useRegisterShortcut({
        id: 'new-thread',
        handler,
        isEnabled: !import.meta.env.VITE_IS_COMPUTER_APP_BUILD && !isMacOS,
    });
}
//# sourceMappingURL=useNewThreadShortcut.js.map